/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AWSSQSCredentials = {
  /**
   * AWS Access Key ID.
   */
  key: string;
  /**
   * AWS Secret Access Key.
   */
  secret: string;
  /**
   * Optional AWS Session Token (for temporary credentials).
   */
  session?: string | undefined;
};

/** @internal */
export const AWSSQSCredentials$inboundSchema: z.ZodType<
  AWSSQSCredentials,
  z.ZodTypeDef,
  unknown
> = z.object({
  key: z.string(),
  secret: z.string(),
  session: z.string().optional(),
});
/** @internal */
export type AWSSQSCredentials$Outbound = {
  key: string;
  secret: string;
  session?: string | undefined;
};

/** @internal */
export const AWSSQSCredentials$outboundSchema: z.ZodType<
  AWSSQSCredentials$Outbound,
  z.ZodTypeDef,
  AWSSQSCredentials
> = z.object({
  key: z.string(),
  secret: z.string(),
  session: z.string().optional(),
});

export function awssqsCredentialsToJSON(
  awssqsCredentials: AWSSQSCredentials,
): string {
  return JSON.stringify(
    AWSSQSCredentials$outboundSchema.parse(awssqsCredentials),
  );
}
export function awssqsCredentialsFromJSON(
  jsonString: string,
): SafeParseResult<AWSSQSCredentials, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AWSSQSCredentials$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AWSSQSCredentials' from JSON`,
  );
}
